/** Legacy intake form ids (frozen mobile contract — keep in sync with socket seeds). */
export const SERVICE_INTAKE_FORM_ID = 'd992a5ea-ff50-11e7-ae46-5065f32acd38'
export const MISSION_INTAKE_FORM_ID = '3eb93865-ff51-11e7-ae46-5065f32acd38'
